import { Tab, TabPanel, TabPanels, Tabs, TabsList } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import AcademicHistory from './academicHistory';
import StudentAcademicHistoryLoader from './academicHistory/parts/StudentAcademicHistoryLoader';
import { EducationalInformation } from './educationalInformation';
import StudentPersonalInformation from './personal-information';
import { RequestsHistory } from './petitionsHistory';
import { StudentDocuments } from './studentDocuments';
import { StudentTutors } from './studentTutors';

export default function StudentFileTabs() {
  const { t } = useTranslation(TranslationsKeys.STUDENT_FILE_TABS);
  const tabs = useMemo(
    () => [
      {
        name: t(`personalInformation`),
        path: '',
        content: <StudentPersonalInformation />,
      },
      {
        name: t(`educationalInformation`),
        path: t(`educationalInformation`),
        content: <EducationalInformation />,
      },
      {
        name: t(`academicHistory`),
        path: t(`academicHistory`),
        content: (
          <StudentAcademicHistoryLoader>
            {(props) => <AcademicHistory {...props} />}
          </StudentAcademicHistoryLoader>
        ),
      },
      {
        name: t(`tutors.tabTitle`),
        path: '',
        content: <StudentTutors />,
      },
      {
        name: t(`petitionsHistory.tabTitle`),
        path: '',
        content: <RequestsHistory />,
      },
      {
        name: t(`studentDocuments.tabTitle`),
        path: '',
        content: <StudentDocuments />,
      },
    ],
    [t],
  );
  return (
    <Tabs defaultTab={tabs[0].name}>
      <TabsList>
        {tabs.map((tab) => (
          <Tab key={tab.name} id={tab.name} children={t(`${tab.name}`)} />
        ))}
      </TabsList>
      <TabPanels>
        {tabs.map((tab) => (
          <TabPanel key={tab.name} id={tab.name} children={tab.content} />
        ))}
      </TabPanels>
    </Tabs>
  );
}
